import { createI18n } from "vue-i18n";

let locale = localStorage.getItem('lang')

const i18n = createI18n({
    legacy: false, //处理报错信息，默认为真
    locale: locale, // 默认使用系统语言
    messages: {
        zh: require('./zh.json'),
        en: require('./en.json'),
        de: require('./de.json'),
    },
});

export default i18n;